const generateShortId = () => {
  return crypto.randomUUID();
};

export default generateShortId;
